import React from 'react';
import ServiceDetailTemplate from '../components/service/ServiceDetailTemplate';

function Agro() {
    const data = {
        title: "Agro",
        // Seguindo a sequência: /assets/images/novos/1/2.png
        mainImage: "/assets/images/novos/1/2.png",
        description1: "Oferecemos soluções financeiras e estratégicas completas para produtores rurais e empresas que compõem a cadeia do agronegócio.",
        description2: "Nosso foco é conectar o campo ao mercado de capitais, garantindo recursos para custeio, investimento e expansão da produção.",
        cards: [
            // Mantendo os ícones conforme o padrão anterior: /assets/images/servicos/3/1.png
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Crédito Rural", 
                disc: "Linhas específicas para custeio e investimento em infraestrutura." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "CRA", 
                disc: "Emissão de Certificados de Recebíveis do Agronegócio." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Crédito Privado", 
                disc: "Acesso a investidores focados no setor produtivo rural." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Estruturação Safra", 
                disc: "Planejamento financeiro para garantir o ciclo completo da lavoura." 
            }
        ],
        processSteps: [
            { title: "Ciclo Produtivo", disc: "Entendemos a sazonalidade da sua cultura (Soja, Milho, Algodão)." },
            { title: "Modelagem", disc: "Estruturação de garantias e prazos alinhados à colheita." },
            { title: "Conexão", disc: "Liberação de recursos via fundos especializados no Agro." }
        ],
        benefitTitle: "Atuação Segmentada",
        benefitDisc: "Especialistas em diversas culturas e escalas produtivas:",
        benefits: [
            "Expertise em Fruticultura e Grãos",
            "Planejamento financeiro do produtor",
            "Segurança jurídica em operações de CRA",
            "Inteligência de mercado para o campo"
        ]
    };

    return <ServiceDetailTemplate {...data} />;
}

export default Agro;